import React from 'react';
import moment from 'moment';

const SVGHelper = {
    title: (value) => {
        const titleProps = {
            width: '100%',
            height: '55',
            style: {
                fill: '#1E252E',
                fontSize: '36px',
                fontWeight: 400,
            },
        };

        return (
            <svg {...titleProps}>
                <text y={35}>{value}</text>
            </svg>
        );
    },
    main: ({ mainValue, extraValue, specialColor }) => {
        const mainProps = {
            fontSize: 80,
            fontWeight: 500,
        };

        const extraProps = {
            fontSize: 30,
            fontWeight: 400,
            y: 60,
            style: { marginLeft: '20px' }
        };

        if (specialColor) {
            mainProps.fill = specialColor;
            extraProps.fill = specialColor;
        }

        let value = <text y={60} {...mainProps}>{mainValue}</text>;
        if (extraValue) {
            value = (
                <text y={60}>
                    <tspan width="100%" height="90" {...mainProps}>
                        {mainValue}
                    </tspan>
                    <tspan {...extraProps}>
                        {extraValue}
                    </tspan>
                </text>
            );
        }

        return (
            <svg width="100%" height="90">
                {value}
            </svg>
        );
    },
};

const CompetitionGoalWidget = (props) => {
    const { widget, companyProfile, slide } = props;
    const customTextColor = slide ? slide.custom.bgColor : companyProfile.colors.mainBg;

    let points = slide ? slide.competitionSettings.goals : 1000;
    
    return (
        <div className="competition-goal-widget">
            {SVGHelper.title('Goals')}
            {SVGHelper.main({ mainValue: points, extraValue: 'Score', specialColor: customTextColor })}
        </div>
    );
};

CompetitionGoalWidget.propTypes = {
    slide: React.PropTypes.object,
};

export default CompetitionGoalWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CompetitionWidgets/CompetitionGoalWidget.jsx
 **/